import * as d3 from "d3";
import { elementsD3js } from "./hook";
import { isMobile, widthAndHeigth } from "../../utils/screenValidations/screen";
import Role from "../../utils/interfaces/IRole";

interface ICords {
	x: number;
	y: number
}

export function calcularDistancia(oldCords: ICords, newCords: ICords): number {
	const dx = oldCords.x - newCords.x;
	const dy = oldCords.y - newCords.y;
	return Math.sqrt(dx * dx + dy * dy);
}

function gerarCoordenadaAleatoria(width: number, height: number, coordsRelated: Role, relatedRole: Role): ICords {
	const r = d3.randomUniform(40, 90)();

	// generate coords based in linkforce
	if (coordsRelated && coordsRelated.related_roles.length > 0) {

		const filterRole = coordsRelated.related_roles.find(el => el.role_id === relatedRole.role_id) || { link_force: 2 }
		const { link_force = 2 } = filterRole
		const { x, y } = coordsRelated


		const calculateX = d3.randomUniform(x - (link_force * 20), x + (link_force * 20))()
		const calculateY = d3.randomUniform(y - (link_force * 20), y + (link_force * 20))()
		return {
			x: d3.randomUniform(x, +(calculateX < 30 ? r : calculateX > width - 20 ? width - 40 : calculateX))(),
			y: d3.randomUniform(y, +(calculateY < 30 ? r : calculateY > height - 20 ? height - 40 : calculateY))(),
		};
	}
	return {
		x: d3.randomUniform(r, width - r)(),
		y: d3.randomUniform(r, height - r)(),
	};

}


export function gerarNovaCoordenada(arrayCoordenadas: Role[], distanciaMinima: number, width: number, height: number, relatedRoles: Role): any {

	const filterRelated = arrayCoordenadas.filter(nodes => nodes.related_roles.find(related => related.role_id === relatedRoles.role_id))
	const novaCoordenada = gerarCoordenadaAleatoria(width, height, filterRelated.slice(-1)[0] || null, relatedRoles);
	const muitoProximo = arrayCoordenadas.some((coord: any) => calcularDistancia(coord, novaCoordenada) < distanciaMinima);

	if (muitoProximo && Object.keys(novaCoordenada).length > 0) {
		return gerarNovaCoordenada(arrayCoordenadas, distanciaMinima, width, height, relatedRoles);
	} else {
		return novaCoordenada
	}
}
interface IData {
	nodes: any[],
	links: any
}
export const zoom = d3.zoom()
	.extent([[0, 0], [widthAndHeigth().width, widthAndHeigth().height]])
	.scaleExtent([isMobile() ? 0.4 : 1, 6])


export default function D3Chart(svgElement: any, data: IData, onClickNode: (node: Role, isFiltered?: boolean,) => void, onMouseEnter: (node: Role) => void, onMouseLeave: () => void,) {
	if (data.nodes.length === 0) return


	svgElement.attr("width", widthAndHeigth().width);
	svgElement.attr("height", widthAndHeigth().height);
	svgElement.attr("viewBox", [0, 0, widthAndHeigth().width, widthAndHeigth().height]);

	const d3JsElements = elementsD3js(svgElement, { nodes: data.nodes } as any);

	if (d3JsElements?.node) {
		d3JsElements.node.on("mouseenter", (_: any, node: Role) => onMouseEnter(node)).on("mouseleave", onMouseLeave).on('click', (_: any, node: any) => {
			onClickNode(node, false)
		})
	}
	const selectContainer = d3.select('g.container-nodes')
	svgElement.call(zoom
		.on("zoom", zoomed));
	// if (isMobile()) {
	// 	svgElement.transition().duration(700).call(zoom.transform, d3.zoomIdentity.translate(-widthAndHeigth().width / 2, -widthAndHeigth().height / 6).scale(0.5));
	// }

	function zoomed({ transform }: any) {
		selectContainer.attr("transform", transform);
	}
}
